import { IProductItem } from "interfaces";
import { convertCurrency, currencySymbol, formatNumber } from "utills/helpers";

interface ProductCardProps {
  data?: IProductItem[];
  pageSize: number;
  currentPage: number;
  orderCurrency: string;
  rate: number;
}

export const ProductCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  orderCurrency = "",
  rate,
}: ProductCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IProductItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Ticket name
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.product_name_en}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Quantity</p>
            <p className="flex-1 text-right text-sm leading-6">
              {formatNumber(item.quantity ?? 0)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Price</p>
            <p className="flex-1 text-right text-sm leading-6">
              {currencySymbol()}{" "}
              {convertCurrency(item.subtotal ?? 0, orderCurrency ?? "", rate)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">
              Discount amount
            </p>
            <p className="flex-1 text-right text-sm leading-6">
              {currencySymbol()}{" "}
              {convertCurrency(
                item.discount_amount ?? 0,
                orderCurrency ?? "",
                rate
              )}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Total</p>
            <p className="flex-1 text-right text-sm leading-6">
              {currencySymbol()}{" "}
              {convertCurrency(
                item.grand_total ?? 0,
                orderCurrency ?? "",
                rate
              )}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Used code</p>
            <p className="flex-1 text-right text-sm leading-6">{item.coupon}</p>
          </li>
        </div>
      ))}
    </ul>
  );
};
